export default __webpack_public_path__ + "mark_2.mp4";